/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { I18n } from 'aws-amplify';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { Button } from '@material-ui/core';
import './NormalViewContractDetail.css';

import LoadingPanel from '@/component/common/LoadingPanel';
import UpdateContract from './UpdateContract/UpdateContract';
import UpdateContractConfirm from './UpdateContractConfirm/UpdateContractConfirm';
import ChoosePaymentConfirm from './ChoosePaymentConfirm/ChoosePaymentConfirm';

import Utils from '@/common/utils/utils';
import { CONTRACT_SCREEN_MANAGEMENT } from '@/common/constant/NormalContractManagementConstant';
import { initContractDetail } from '@/component/rootOrganization/EditOrganizationHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import {
    handleRedirect,
    currentContract,
    usingStageStatus,
    usingFunctions,
    hanldeShowDialogPolicy,
    handleCustomInitUpdateContractState,
    onClickReloadData,
    closeBtnUpdateContract
} from './NormalViewContractDetailHanlder.js';
import DialogPolicy from './DialogPolicy';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';

export default function NormalViewContractDetail(props) {
    const { enqueueSnackbar } = useSnackbar();
    const corporationDetail = useRecoilValue(corporationAtom);
    const [isLoading, setIsLoading] = useState(false);
    const [labelUser, setLabelUser] = useState(true);
    const [labelUsageStatus, setLabelUsageStatus] = useState(true);
    const [labelUsedFunctions, setLabelUsedFunctions] = useState(true);
    const [contractDetail, setContractDetail] = useState({});
    const [corpLimitValue, setCorpLimitValue] = useState({});
    const [currentScreen, setCurrentScreen] = useState(
        CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN
    );
    const [redirectBtns, setRedirectBtns] = useState(
        CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.REDIRECT_BUTTONS
    );

    const [isUpdateConfirm, setIsUpdateConfirm] = useState(false);
    const [updateContractData, setUpdateContractData] = useState({})

    const [onSaleProductList, setOnSaleProductList] = useState([]);
    const [onSaleEditionList, setOnSaleEditionList] = useState([]);
    const [product, setProduct] = useState({});
    const [edition, setEdition] = useState({});
    const [version, setVersion] = useState({});
    const [paymentCycle, setPaymentCycle] = useState('');
    const [payment, setPayment] = useState();
    const [basicSetting, setBasicSetting] = useState({});
    const [advanceSetting, setAdvanceSetting] = useState({})

    const [isOpenPolicy, setOpenPolicy] = useState(false);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [paymentMethod, setPaymentMethod] = useState(
        CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER
    );
    const [checkErr, setCheckErr] = useState(false);
    const userDetail = useRecoilValue(userAtom);
    const [isShowPopUpReload, setIsShowPopUpReload] = useState({isOpen: false, message: ''});
    const [triggerReload, setTriggerReload] = useState('');
    const [amountValue, setAmountValue] = useState(0);
    const [currentVersionInfo, setCurrentVersionInfo] = useState({});
    const [resetData, setResetData] = useState({});
    const [isShowPopupCancel, setIsShowPopupCancel] = useState(false);
    const [currentPaymentCycle, setCurrentPaymentCycle] = useState('')
    const [corporationData, setCorporationData] = useState({});

    useEffect(() => {
        setIsLoading(true);
        initContractDetail(props?.API, corporationDetail.id)
            .then(data => {
                if (!data || Utils.isEmptyObject(data)) return setIsLoading(false);
                setContractDetail(data);
                setCorpLimitValue(data?.corporationData?.limitValue);
                setCorporationData(data?.corporationData);
                handleCustomInitUpdateContractState(
                    data,
                    setOnSaleProductList,
                    setOnSaleEditionList,
                    setProduct,
                    setEdition,
                    setVersion,
                    setPaymentCycle,
                    setPayment,
                    setBasicSetting,
                    setAdvanceSetting,
                    setResetData,
                    setCurrentVersionInfo,
                    setCurrentPaymentCycle
                );

                setIsLoading(false);
            })
            .catch(error => {
                console.error('initContractDetail >>> error >>>', error)
                setIsLoading(false);
            });
    }, [corporationDetail.id, triggerReload]);

    // close tabid
    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
            if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
            closePanelTab({
                event: null,
                panelType: currentPanelInfo.type,
                panelId: props.panelId,
                tabId: props.tabId
            });
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    const hanldeToggleCollapse = collapse => (collapse ? 'accordionForm--show' : '');

    const showClassUsingStage = ({ item, index }) => {
        let className = 'accordion normal-underline';
        const indexLastOfUseStage = usingStageStatus(contractDetail?.corporationData).length - 1;
        if (indexLastOfUseStage === index) {
            className = className.replace(' normal-underline', '');
        }
        if (item.limit < item.used) {
            className += ' normal-error';
        }
        if (item.custom) {
            className += ' root-custom';
        }
        return className;
    };

    const isError = (max, min) => (max < min ? 'normal-error' : '');

    useEffect(() => {
        switch (currentScreen) {
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN:
                setRedirectBtns(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.REDIRECT_BUTTONS);
                break;
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN:
                setRedirectBtns(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.REDIRECT_BUTTONS);
                break;
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.SCREEN:
                setRedirectBtns(
                    CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.REDIRECT_BUTTONS
                );
                break;
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN:
                setRedirectBtns(
                    CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.REDIRECT_BUTTONS
                );
                break;
            default:
                break;
        }
    }, [currentScreen]);

    const handleRenderScreen = screen => {
        switch (screen) {
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN:
                return (
                    <>
                        <div className="normal-product">
                            {currentContract(contractDetail).map(item => (
                                <div className="product-expied normal-underline" key={item.label}>
                                    <span className="normal-label">{item.label}</span>
                                    {!Utils.isEmpty(item.isNameProduct) ? (
                                        <OverFlowTooltipWithTabsMui
                                            className="normal-content d-inline-block w-50 text-right"
                                            value={item.content}
                                        />
                                    ) : (
                                        <span className="normal-content">{item.content}</span>
                                    )}
                                </div>
                            ))}
                            {/* <div className="normal-error d-inline-block"> // out scoped
                                <i>icon</i>
                                <span className="ml-1">
                                    近いうちにお支払期限になります。契約変更がなければ、プランを移行されます。
                                </span>
                            </div> */}
                        </div>

                        <div className="normal-collapse">
                            {/* LABEL-USER */}
                            <div
                                className={`accordionForm ${hanldeToggleCollapse(labelUser)}`}
                                id="label-user"
                            >
                                <label
                                    className="accordionHead accordionHead-text"
                                    onClick={() => setLabelUser(!labelUser)}
                                >
                                    {I18n.get('LABEL-USER')}
                                </label>
                                <div className="accordionContent">
                                    <div className="accordion normal-underline pt-1">
                                        <span className="normal-label">
                                            {I18n.get('LABEL-TABLE-USAGE-DETAIL')}
                                        </span>
                                        <span className="normal-content">
                                            {I18n.get('LABEL-TABLE-USAGE-STATUS')}
                                        </span>
                                    </div>
                                    <div
                                        className={`accordion ${isError(
                                            corpLimitValue?.maxNumOfGeneralUser,
                                            corpLimitValue?.numOfGeneralUser
                                        )}`}
                                    >
                                        <span className="normal-label">
                                            {I18n.get('LABEL-NUMBER-OF-GENERAL-USER')}
                                        </span>
                                        <span className="normal-content">
                                            {/* <span>(パートナー 2)</span> // out scoped */}
                                            {corpLimitValue?.numOfGeneralUser || 0} /&nbsp;
                                            {corpLimitValue?.maxNumOfGeneralUser || 0}&nbsp;
                                            {I18n.get('LABEL-ID')}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* LABEL-USAGE-STATUS */}
                            <div
                                className={`accordionForm ${hanldeToggleCollapse(labelUsageStatus)}`}
                                id="label-usage-status"
                            >
                                <label
                                    className="accordionHead accordionHead-text"
                                    onClick={() => setLabelUsageStatus(!labelUsageStatus)}
                                >
                                    {I18n.get('LABEL-USAGE-STATUS')}
                                </label>
                                <div className="accordionContent">
                                    <div className="accordion normal-underline pt-1">
                                        <span className="normal-label">
                                            {I18n.get('LABEL-TABLE-USAGE-DETAIL')}
                                        </span>
                                        <span className="normal-content">
                                            {I18n.get('LABEL-TABLE-USAGE-STATUS')}
                                        </span>
                                    </div>
                                    {usingStageStatus(
                                        contractDetail?.corporationData,
                                        contractDetail?.contractDetail,
                                        contractDetail?.versionData
                                    ).map(
                                        (item, index) =>
                                            item.enable && (
                                                <div
                                                    key={index}
                                                    className={showClassUsingStage({ item, index })}
                                                >
                                                    <span className="normal-label">
                                                        {item.label}
                                                    </span>
                                                    <span className="normal-content">
                                                        <span className="fs-15 fw-500">
                                                            {item.used} / {item.limit}
                                                        </span>
                                                        &nbsp;
                                                        {item.subLabel}
                                                    </span>
                                                </div>
                                            )
                                    )}
                                </div>
                            </div>

                            {/* LABEL-USED-FUNCTIONS */}
                            <div
                                className={`accordionForm ${hanldeToggleCollapse(
                                    labelUsedFunctions
                                )}`}
                                id="label-used-functions"
                            >
                                <label
                                    className="accordionHead accordionHead-text"
                                    onClick={() => setLabelUsedFunctions(!labelUsedFunctions)}
                                >
                                    {I18n.get('LABEL-USED-FUNCTIONS')}
                                </label>
                                <div className="accordionContent service-public">
                                    {usingFunctions(corpLimitValue, corporationData).map(
                                        (item, index) => (
                                            <div className="accordion" key={index}>
                                                <span className="normal-label using-function-settings fw-500">
                                                    {item?.label}
                                                </span>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                );
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN:
                return (
                    <UpdateContract
                        amountValue={amountValue}
                        setAmountValue={setAmountValue}

                        updateContractData={updateContractData}
                        setUpdateContractData={setUpdateContractData}

                        onSaleProductList={onSaleProductList}
                        setOnSaleProductList={setOnSaleProductList}
                        onSaleEditionList={onSaleEditionList}
                        setOnSaleEditionList={setOnSaleEditionList}

                        product={product}
                        setProduct={setProduct}
                        edition={edition}
                        setEdition={setEdition}
                        version={version}
                        setVersion={setVersion}
                        paymentCycle={paymentCycle}
                        setPaymentCycle={setPaymentCycle}

                        payment={payment}
                        setPayment={setPayment}

                        basicSetting={basicSetting}
                        setBasicSetting={setBasicSetting}
                        advanceSetting={advanceSetting}
                        setAdvanceSetting={setAdvanceSetting}

                        currentScreen={currentScreen}
                        isUpdateConfirm={isUpdateConfirm}
                        setIsUpdateConfirm={setIsUpdateConfirm}
                        setIsLoading={setIsLoading}
                        setCheckErr={setCheckErr}
                        props={props}
                        contractDetail={contractDetail?.contractDetail}
                        versionDataCurrent={resetData?.version}
                        currentPaymentCycle={currentPaymentCycle}
                    />
                );
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.SCREEN:
                return (<UpdateContractConfirm
                            amountValue={amountValue}
                            advanceSetting={advanceSetting}
                            basicSetting={basicSetting}
                            currentScreen={currentScreen}
                            edition={edition}
                            payment={payment}
                            paymentCycle={paymentCycle}
                            product={product}
                            version={version}
                            contractDetail={contractDetail?.contractDetail}
                        />
                );
            case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN:
                return (
                    <ChoosePaymentConfirm
                        setPaymentMethod={setPaymentMethod}
                        paymentMethod={paymentMethod}
                    />
                );
            default:
                return <LoadingPanel isLoading={isLoading} />;
        }
    };

    const updateDto = {
        corporationId: corporationDetail.id,
        userId: userDetail.id,
        contractId: contractDetail.id,
        method: paymentMethod
    }

    const hanldeCloseUpdateContract = () => {
        closeBtnUpdateContract(
            CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN,
            resetData,
            setOnSaleProductList,
            setOnSaleEditionList,
            setProduct,
            setEdition,
            setVersion,
            setPaymentCycle,
            setPayment,
            setBasicSetting,
            setAdvanceSetting,
            setIsUpdateConfirm,
            setIsShowPopupCancel,
            setCheckErr,
            setCurrentScreen,
            setCurrentVersionInfo
        )// delete function if using popup cancel
    }

    useEffect(()=>{
        console.log('checkErr :>> ', checkErr);
    }, [checkErr])

    return (
        <div className="normal-wrapper">
            <LoadingPanel isLoading={isLoading} />
            <div className="normal-nav normal-underline">
                <div className="normal-btn-group">
                    {redirectBtns.map((btn, index) => (
                        <Button
                            key={index}
                            className={`
                                btn-send btn-hg32 
                                ${btn.outline ? 'btn-primary' : 'btn-outline-primary'} 
                                ${btn.label === I18n.get('CM-BUTTON-CANCEL') && 'btn-light'}
                            `}
                            variant="contained"
                            color="primary"
                            data-cy="btn-submit-add-ticket"
                            onClick={async () =>
                                await handleRedirect(
                                    currentScreen,
                                    setCurrentScreen,
                                    btn.label,
                                    setOpenPolicy,
                                    updateDto,
                                    enqueueSnackbar,
                                    props?.API,
                                    setIsLoading,
                                    setCheckErr,
                                    contractDetail,
                                    updateContractData,
                                    setBasicSetting,
                                    setAdvanceSetting,
                                    setIsShowPopUpReload,
                                    product,
                                    edition,
                                    version,
                                    paymentCycle,
                                    payment,
                                    currentVersionInfo,
                                    basicSetting,
                                    advanceSetting,
                                    isUpdateConfirm,
                                    setIsShowPopupCancel,
                                    hanldeCloseUpdateContract,
                                    setTriggerReload
                                )
                            }
                            disabled={btn?.defaultDisable && checkErr}
                        >
                            {btn.label}
                        </Button>
                    ))}
                </div>
            </div>

            {handleRenderScreen(currentScreen)}
            {isOpenPolicy && (
                <DialogPolicy
                    openPolicy={isOpenPolicy}
                    onShow={kind =>
                        hanldeShowDialogPolicy(isOpenPolicy, setOpenPolicy, setCurrentScreen, kind)
                    }
                />
            )}

            <ConfirmDialog
                isOpen={isShowPopUpReload.isOpen}
                msgConfirm={
                    isShowPopUpReload?.message
                        ? I18n.get(isShowPopUpReload?.message)
                        : I18n.get('COMMSG030')
                }
                okCallBack={() =>
                    onClickReloadData(setCurrentScreen, setIsShowPopUpReload, setTriggerReload, setPaymentMethod)
                }
            />

            {/* popup cancel: if change data, it will display --> current hidden because outscoped */}
            {false && (
                <ConfirmDialog
                    isOpen={isShowPopupCancel}
                    msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                    // okCallBack={}
                    closeCallBack={() =>
                        closeBtnUpdateContract(
                            CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN,
                            resetData,
                            setOnSaleProductList,
                            setOnSaleEditionList,
                            setProduct,
                            setEdition,
                            setVersion,
                            setPaymentCycle,
                            setPayment,
                            setBasicSetting,
                            setAdvanceSetting,
                            setIsUpdateConfirm,
                            setIsShowPopupCancel,
                            setCheckErr,
                            setCurrentScreen,
                            setCurrentVersionInfo
                        )
                    }
                    cancelCallBack={() => setIsShowPopupCancel(false)}
                    textSubmit={I18n.get('COMBTN002')}
                    textClose={I18n.get('COMBTN007')}
                    isShowClassnameButton={false}
                />
            )}
        </div>
    );
}
